module.exports = __webpack_public_path__ + "img/q1.aac6f7e1.png";